const reportWebVitals = (onPerfEntry) => {
  // disabled
};

export default reportWebVitals;
